import { GET_PAYMENT_IPG, GET_PAYMENT_IPG_FAIL, GET_PAYMENT_IPG_PUBLIC, GET_PAYMENT_IPG_SUCCESS, PAYMENT_MELLI_RESET } from "./actionTypes";


export const getPaymentMelli = amount =>({
    type:GET_PAYMENT_IPG,
    payload:amount
})

export const getPaymentMelliPublic = values =>({
    type:GET_PAYMENT_IPG_PUBLIC,
    payload:values
})

export const getPaymentIpgSuccess = redirectUrl =>({
    type:GET_PAYMENT_IPG_SUCCESS,
    payload:redirectUrl
})

export const getPaymentMelliFail = error =>({
    type:GET_PAYMENT_IPG_FAIL,
    payload:error
})



export const paymentIpgReset = () =>({
    type:PAYMENT_MELLI_RESET
})